/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onAddNote = /* GraphQL */ `
  subscription OnAddNote($customer_id: String) {
    onAddNote(customer_id: $customer_id) {
      account_id
      created_at
      customer_id
      id
      note
      updated_at
    }
  }
`;
